import * as Types from '../../network/graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', avatarWebPUrl?: string | null, id: string, username: string, email: string, firstName?: string | null, isProfessionalSeller: boolean, isSelected: boolean, isSeller: boolean, isStaff: boolean, language?: string | null, lastName?: string | null, legacyId: number, phoneNumber?: string | null, birthdate?: Date | null, shippingAddresses: Array<{ __typename?: 'ShippingAddress', id: string, inputLine1: string, inputPostalCode: string, inputCity: string, inputCountry: string, region?: string | null, resolvedCountry: { __typename?: 'Country', id: string, iso2Code: string, name: string } }>, sellerConfig?: { __typename?: 'SellerConfig', percentageFee: number, acceptedStudioConditionsOn?: Date | null, stripeMissingInfoDueDate?: Date | null, stripeAccountPayoutsEnabled: boolean, stripeAccountChargesEnabled: boolean, shouldAcceptStripeTermsOfServices: boolean, canAccessPreAuth: boolean, canAccessInventory: boolean, canAccessWebRTC: boolean, canBeContactedByCustomersForOrderIssues: boolean, canCreateShop: boolean, canCreateShow: boolean, canCreatePreOrders?: boolean | null, canRequestOrderCancellation: boolean, canSkipStripeDebitAgreement: boolean, canStreamAbove720p: boolean, canUseLedger: boolean, canUseConversation?: boolean | null, canCreateWheel: boolean, canManageSubAccounts: boolean, canAccessHomeMetrics: boolean, canManageAccountSettings: boolean, canHandDeliver: boolean, canUseBreaks: boolean, canUseBulkShipping: boolean, easyShippingMethod?: Types.EasyShippingMethod | null, hasBankAccountConfiguredInStripe: boolean, isInventoryInitialized: boolean, sellerCurrency: Types.Currency, shouldAcceptStripeDebitAgreement: boolean, createdAt: Date, isEligibleForDac7: boolean, sellerType?: Types.SellerType | null, taxIdentificationNumber?: string | null, countryOfBirthIso2Code?: any | null, cityOfBirth?: string | null, dac7ValidatedAt?: Date | null, favoriteShippingLabelFormat?: Types.FavoriteShippingLabelFormat | null, fixedFee: { __typename?: 'AmountWithCurrency', amount: number, currency: Types.Currency }, streamingConfigs: Array<{ __typename?: 'SellerStreamingConfig', url: string, streamKey: string, name: string }>, country: { __typename?: 'Country', name: string, iso3Code: string, iso2Code: string, id: string }, defaultShowLanguage: { __typename?: 'Language', isFollowing: boolean, id: string, code: string }, sellerTier: { __typename?: 'SellerTier', id: string, name: string, showStartMaxTime?: number | null }, shippingAddress?: { __typename?: 'SellerConfigShippingAddress', city: string, countryIso2Code: any, email: string, firstName: string, houseNumber?: string | null, lastName: string, phoneNumber: string, street: string, street2?: string | null, zipCode: string } | null, favoriteParentCategory?: { __typename?: 'ParentCategory', slug: string } | null, dataConsent?: { __typename?: 'SellerDataConsent', hasGivenConsentForEmailsAt?: Date | null, hasGivenConsentForSMSAt?: Date | null, hasReceivedDataConsentRequest: boolean } | null } | null, sellerCompany?: { __typename?: 'SellerCompany', legalName?: string | null, address?: string | null, city?: string | null, zipCode?: string | null, country?: any | null, registrationNumber?: string | null, taxId?: string | null, vatId?: string | null } | null } | null };


export const GetUserDocument = gql`
    query GetUser {
  viewer {
    avatarWebPUrl
    id
    username
    email
    firstName
    isProfessionalSeller
    isSelected
    isSeller
    isStaff
    language
    lastName
    legacyId
    phoneNumber
    birthdate
    shippingAddresses {
      id
      inputLine1
      inputPostalCode
      inputCity
      inputCountry
      resolvedCountry {
        id
        iso2Code
        name
      }
      region
    }
    sellerConfig {
      percentageFee
      fixedFee {
        amount
        currency
      }
      acceptedStudioConditionsOn
      stripeMissingInfoDueDate
      stripeAccountPayoutsEnabled
      stripeAccountChargesEnabled
      streamingConfigs {
        url
        streamKey
        name
      }
      shouldAcceptStripeTermsOfServices
      canAccessPreAuth
      canAccessInventory
      canAccessWebRTC
      canBeContactedByCustomersForOrderIssues
      canCreateShop
      canCreateShow
      canCreatePreOrders
      canRequestOrderCancellation
      canSkipStripeDebitAgreement
      canStreamAbove720p
      canUseLedger
      canUseConversation
      canCreateWheel
      canManageSubAccounts
      canAccessHomeMetrics
      canManageAccountSettings
      canHandDeliver
      canUseBreaks
      canUseBulkShipping
      country {
        name
        iso3Code
        iso2Code
        id
      }
      defaultShowLanguage {
        isFollowing
        id
        code
      }
      easyShippingMethod
      hasBankAccountConfiguredInStripe
      isInventoryInitialized
      sellerCurrency
      sellerTier {
        id
        name
        showStartMaxTime
      }
      shouldAcceptStripeDebitAgreement
      shippingAddress {
        city
        countryIso2Code
        email
        firstName
        houseNumber
        lastName
        phoneNumber
        street
        street2
        zipCode
      }
      favoriteParentCategory {
        slug
      }
      createdAt
      dataConsent {
        hasGivenConsentForEmailsAt
        hasGivenConsentForSMSAt
        hasReceivedDataConsentRequest
      }
      isEligibleForDac7
      sellerType
      taxIdentificationNumber
      countryOfBirthIso2Code
      cityOfBirth
      dac7ValidatedAt
      favoriteShippingLabelFormat
    }
    sellerCompany {
      legalName
      address
      city
      zipCode
      country
      registrationNumber
      taxId
      vatId
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;